<template>
    <div>
        <vx-card class="mb-4">
            <div class="w-full flex flex-no-wrap">
                <div class="w-1/2">
                    <h5 class="mb-4">Request for Device Form</h5>
                    <div class="w-full flex flex-no-wrap" v-if="data.request_code!=''">
                        <div class="table-cell w-1/4 p-4">
                            Request Id
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/4 p-4">
                            <vs-label>{{data.request_code}}</vs-label>
                        </div>
                    </div>
                    <div class="w-full flex flex-no-wrap">
                        <div class="w-1/4 p-4 pt-6">
                            Description
                            <span class="text-danger">*</span>
                        </div>
                        <div class="w-3/4 p-4">
                            <vs-input
                                    type="text"
                                    placeholder="Description"
                                    v-model="data.description"
                                    class="w-full no-icon-border"
                                    name="description"
                                    v-validate="'required'"
                                    data-vv-validate-on="blur"
                            />
                            <span class="text-danger text-sm">{{ errors.first('description') }}</span>
                        </div>
                    </div>
                    <div class="w-full flex flex-no-wrap">
                        <div class="w-1/4 p-4 pt-6">
                            Tags
                            <span class="text-danger">*</span>
                        </div>
                        <div class="w-3/4 p-4">
                            <vue-tags-input
                                    class="w-full no-icon-border"
                                    v-model="tag"
                                    :tags="tags"
                                    @tags-changed="newTags => tags = newTags"
                            />
                        </div>
                    </div>
                    <div class="w-full flex flex-no-wrap">
                        <div class="w-1/4 p-4 pt-6">
                            Expected Date
                            <span class="text-danger">*</span>
                        </div>
                        <div class="w-3/4 p-4">
                            <flatPickr
                                    class="w-full no-icon-border"
                                    :config="configFromdateTimePicker"
                                    v-model="valDate"
                                    placeholder="Expected Date"
                            />
                        </div>
                    </div>
                    <div class="w-full flex flex-no-wrap">
                        <div class="w-1/4 p-4 pt-6">
                            Device Type
                            <span class="text-danger">*</span>
                        </div>
                        <div class="w-3/4 p-4">
                            <v-select placeholder="Device Type" name="device type" v-validate="'required'" :options="device_type" v-model="data.device_type"></v-select>
                            <span class="text-danger text-sm" v-show="errors.has('device type')">{{ errors.first('device type') }}</span>
                        </div>
                    </div>
                    <div class="w-full flex flex-no-wrap">
                        <div class="w-1/4 p-4 pt-6">
                            Placement
                            <span class="text-danger">*</span>
                        </div>
                        <div class="w-3/4 p-4">
                            <v-select placeholder="Placement" :options="merchant_list" v-model="placement"></v-select>
                            <span class="text-danger text-sm" v-show="errors.has('placement')">{{ errors.first('placement') }}</span>
                        </div>
                    </div>
                </div>
                <div class="hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                    <img class="w-1/2 mx-auto" src="@/assets/images/pages/graphic-4.png" alt="login"/>
                </div>
            </div>

            <vs-divider>SERVICE CONFIGURATIONS</vs-divider>
            <div class="w-full flex flex-no-wrap">
                <vs-tabs>
                    <vs-tab label="Payment" icon-pack="feather" icon="icon-dollar-sign">
                        <div class="tab-container">
                            <div class="w-full">
                                <div class="w-full flex flex-no-wrap">
                                    <div class="table-cell w-1/4 p-4 py-10">
                                        Payment Acceptance
                                        <span class="text-danger">*</span>
                                    </div>
                                    <div class="w-3/4 p-4 pt-2 flex flex-wrap">
                                        <div class="w-1/2" :key="index" v-for="(data, index ) in payment_channel_list">
                                            <vs-checkbox
                                                    class="mt-8"
                                                    v-model="payment_channel_selected"
                                                    :vs-value="data.id"
                                                    disabled="true"
                                            >{{data.name}}
                                            </vs-checkbox>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vs-tab>
                    <!-- <vs-tab label="Transport & Tourism" icon-pack="feather" icon="icon-shield">
                      <div class="tab-container">
                        <div class="w-full flex flex-no-wrap">
                          <div class="w-1/2">
                            <h5 class="mb-4">Transport & Tourism</h5>
                          </div>
                        </div>
                      </div>
                    </vs-tab>
                    <vs-tab label="Retails" icon-pack="feather" icon="icon-shield">
                      <div class="tab-container">
                        <div class="w-full flex flex-no-wrap">
                          <div class="w-1/2">
                            <h5 class="mb-4">Retails</h5>
                          </div>
                        </div>
                      </div>
                    </vs-tab>
                    <vs-tab label="Loyalty" icon-pack="feather" icon="icon-shield">
                      <div class="tab-container">
                        <div class="w-full flex flex-no-wrap">
                          <div class="w-1/2">
                            <h5 class="mb-4">Retails</h5>
                          </div>
                        </div>
                      </div>
                    </vs-tab>-->
                </vs-tabs>
            </div>
            <vs-divider class="mt-10">DEVICE INFORMATIONS</vs-divider>

            <div class="w-full flex flex-no-wrap">
                <DeviceList
                        :callback="getData"
                        class="w-full"
                        :dataDevice="data.merchant_device_request_detail"
                />
            </div>
        </vx-card>
        <vx-card>
            <div class="w-full text-right">
                <vs-button type="border" @click="backPage">Cancel</vs-button>
                <vs-button class="ml-4" @click="submitRequest">Submit</vs-button>
            </div>
        </vx-card>
    </div>
</template>

<script>
    import DeviceList from "@/views/device/request-device/details/DeviceList.vue";
    import AxiosCall from "@/global/AxiosCall";
    import {url} from "@/configs/apiUrl";
    import VueTagsInput from "@johmun/vue-tags-input";
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    import vSelect from 'vue-select'

    export default {
        components: {
            DeviceList,
            VueTagsInput,
            flatPickr,
            'v-select': vSelect,
        },
        data() {
            return {
                tag: "",
                tags: [],
                valDate: null,
                configFromdateTimePicker: {
                    minDate: new Date(),
                    maxDate: null,
                    dateFormat: 'd-m-Y'
                },
                data: {
                    request_code: "",
                    device_type: "",
                    description: "",
                    merchant_device_request_detail: []
                },
                device_type: [],
                merchant_list:[],
                placement:'',
                option: [],
                merchant_id:'',
                payment_channel_list: [],
                payment_channel_selected: []
            };
        },
        methods: {
            backPage() {
                this.$router.push({name:'requestForDevice'});
            },
            getData(value) {
                this.data.merchant_device_request_detail = [];
                for (let data of value) {
                    delete data.no;
                    this.data.merchant_device_request_detail.push(data);
                }
            },
            validateForm() {
                return (
                    !this.errors.any() &&
                    this.data.device_type_id !== "" &&
                    this.data.description !== "" &&
                    this.placement !== "" &&
                    this.data.device_type !== "" &&
                    this.valDate !== "" &&
                    this.tags.length > 0
                );
            },
            onDateChange(selectedDates, dateStr) {
                this.$set(this.configFromdateTimePicker, "minDate", dateStr);
            },
            submitRequest() {
                if (!this.validateForm()) {
                    this.$vs.notify({
                        title: "Warning",
                        text: "Please input all required fields!",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "warning",
                        position: "top-right"
                    });
                    return false;
                } else {
                    if (this.data.merchant_device_request_detail.length > 0 && this.payment_channel_selected.length > 0){
                        let payload = {};
                        payload.merchant_id =  this.merchant_id
                        payload.placement = this.placement.id
                        payload.device_type_id = this.data.device_type.id;
                        payload.device_qty = this.data.merchant_device_request_detail.length;
                        payload.notes = this.data.description;
                        payload.status = 'pending'
                        let dateNow = new Date
                        let valDate = (this.valDate == null) ? dateNow.getDate() + "-" + dateNow.getMonth() + "-" + dateNow.getFullYear() : this.valDate
                        payload.expected_date = new Date(
                            valDate
                                .split("-")
                                .reverse()
                                .join("-") 
                            //     +
                            // " " +
                            // "00:00:00"
                        ).toISOString();
                        payload.tag = [];
                        for (let i in this.tags) {
                            payload.tag.push(this.tags[i].text);
                        }
                        payload.description = this.data.description;
                        payload.merchant_device_request_details = this.data.merchant_device_request_detail;
                        let payment_channel_selected = [];

                        for (let data of this.payment_channel_selected) {
                            let result = this.payment_channel_list.find(obj => {
                                return obj.id === data;
                            });
                            payment_channel_selected.push({key: result.code, name: result.name});
                        }

                        for (let i in payload.merchant_device_request_details) {
                            payload.merchant_device_request_details[i].config = {
                                payment_acceptance: payment_channel_selected
                            };
                        }

                        AxiosCall.Post(url.svd.device_request.store, payload).then(response => {
                            if (response.code == 200) {
                                let status = true;
                                this.$router.push({
                                    name: "requestForDevice",
                                    params: {status: status}
                                });
                            }
                        }, error => {
                            console.log(error.response)
                            if (error.response.status == 400)
                                this.$vs.notify({
                                    title: "Warning",
                                    text: error.response.data.message,
                                    iconPack: "feather",
                                    icon: "icon-alert-circle",
                                    color: "warning",
                                    position: "top-right"
                                })
                        })
                    }else{
                        let message
                         message = (this.payment_channel_selected == 0) ? 'Please select payment acceptance!':(( this.data.merchant_device_request_detail.length == 0? 'Please add device!' : ''))

                        this.$vs.notify({
                            title: "Warning",
                            text: message,
                            iconPack: "feather",
                            icon: "icon-alert-circle",
                            color: "warning",
                            position: "top-right"
                        });
                        return false;
                    }

                }

                // const payload = {
                //   data: this.data,
                //   notify: this.$vs.notify
                // };
                //this.$store.dispatch("auth/registerUser", payload);
            }
        },
        created() {

            AxiosCall.Get(url.svd.device_type.selection)
                .then(response => {
                    if (response.code == 200) {
                        this.device_type = response.data;
                        for (let data of this.device_type){
                            data.label= data.name
                        }
                    } else {
                        this.warning("Get device type", "Fail get device type");
                    }
                })
                .catch(() => {
                });
            AxiosCall.Get(url.svd.payment_channel.list_selection).then(resp => {
                this.payment_channel_list = resp.data;
            });
            this.merchant_id = (JSON.parse(localStorage.getItem("userInfo")).merchant.parent_id === 0 || JSON.parse(localStorage.getItem("userInfo")).merchant.parent_id === undefined ) ? JSON.parse(localStorage.getItem("userInfo")).merchant.id : JSON.parse(localStorage.getItem("userInfo")).merchant.parent_id
            AxiosCall.Get(url.svd.merchant.list_by_parent_id+"/"+this.merchant_id).then(resp => {
                this.merchant_list = resp.data;
                for (let data of this.merchant_list){
                    data.label = data.full_name
                }
            });

            AxiosCall.Get(url.svd.merchant.detail + "/" + this.merchant_id).then(response => {
                if (response.code == 200) {
                    for (let data of response.data[0].channels) {
                        this.payment_channel_selected.push(data.id)
                    }
                }
            })
        }
    };
</script>

<style lang="scss">
    .con-input-upload {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        height: 73px;
        text-align: left;
        margin: 0px;
        flex-direction: column;

    .text-input {
        text-align: left;
        width: 80%;
        display: block;
    }

    .vs-upload--button-upload {
        text-align: right;
        width: 20%;
        display: block;
        right: 0;
        bottom: auto;
        margin-right: 10px;
    }

    }

    .centerx {
        display: -webkit-box;
        display: -ms-flexbox;
        margin-right: 5px;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
        -webkit-box-pack: start;
        -ms-flex-pack: start;
        justify-content: flex-start;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
    }

    .vs-select--input,
    .flatpickr-input {
        padding: 0.7rem !important;
        font-size: 1rem;
        border-radius: 5px;
    }

    .vue-tags-input {

    .ti-input {
        padding: 0.4rem;
        font-size: 1rem;
        border-radius: 5px;
    }

    }
</style>



